import blogCat from "../../assest/images/blogCat2.avif"
import BlogCatListCard from "../../components/BlogCatListCard"
import BreadCrumb from "../../components/BreadCrumb"

const Index = ({
    blogCatList,
    isLoading,
    breadcrumbList
}) => {

    return (
        <>
            <section className="mainBanner mb-5" style={{ backgroundImage: `url(${blogCat})` }}>
                <div className="bannerBox">
                    <div className="container">
                        <div className="bannerText">
                            <div className="sliderText">
                                <h2>Blog Categories</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="container">
                <BreadCrumb list={breadcrumbList} />
            </div>
            <BlogCatListCard
                blogList={blogCatList}
                isLoading={isLoading}
            />
        </>
    )
}
export default Index